import {useQuery} from "@tanstack/react-query";
import {eventsEventIdCommentsGet} from "../api/events/eventsEventIdCommentsGet.ts";

export const useEventComments = (eventId: string) => useQuery({
    queryKey: ['comments', eventId],
    queryFn: () => eventsEventIdCommentsGet(eventId).then(r => r.payload)
})